import { Children } from 'react';
import PropTypes from 'prop-types';

const AnalyticsStore = ({ children }) => Children.only(children);

AnalyticsStore.propTypes = {
    data: PropTypes.object.isRequired,
};

export default AnalyticsStore;
